import React, { useState, useEffect } from "react";
import RatingGame from "../../components/RatingGame";
import useGame from "../../hooks/useGame";
import useRatingQuestions from "../../hooks/useRatingQuestions";
import { navigate } from "@reach/router";
import LoadingScreen from "../../components/LoadingScreen";


function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

function GenerateUniqueRandom(min, max, notthisArray) {
  var returnMe = Math.floor(Math.random() * (max - min) + min);
  console.log(notthisArray)

  if (notthisArray.includes(returnMe)) {
    return GenerateUniqueRandom(min, max, notthisArray);
  }

  return returnMe;
}

function GenerateRandom(min, max) {
  return Math.floor(Math.random() * (max - min) + min);
}


//Returns correct answer for most cases, other cases are done in line
function getAnswer(calculation) {
  const calculationParts = calculation;

  if (calculationParts.length === 3) {
    const [number1, operator, number2] = calculationParts;

    switch (operator) {
      case "-":
        return parseInt(number1) - parseInt(number2);
      case "+":
        return parseInt(number1) + parseInt(number2);
      default:
        break;
    }
  }
  else
    return 0;
}

//Gets a number within 10 of the correct answer, doesn't return repeat values
function getWrongAnswer(correctAnswer, existingWrongAnswers) {
  //Prep variables
  var output = 0;
  var getAnswer = true;
  //Wierd while loop, decided not to change it as my while loops keep breaking for some reason
  do {
    //Random for normal numbers
    if (correctAnswer > 1)
    {
      output = parseInt(correctAnswer) - 10 + Math.round(Math.random() * 20);
    }
    //Random for decimal numbers
    else
    {
      output = Math.round(Math.random() * 90) / 100;
      output = output.toFixed(2);

      if(output[3] == "0")
      output = parseFloat(output).toFixed(1);
    }

    getAnswer = false;
    //Repeat if below 0 or the same as the correct answer
    if (output === correctAnswer || output < 0)
      getAnswer = true;
    //Repeat if a duplicate wrong answer
    for (var i = 0; i < existingWrongAnswers.length; i++)
      if (existingWrongAnswers[i] == output)
        getAnswer = true;
  }
  while (getAnswer === true);

  return output;
}

//Returns the parameters of the random number
function RandomRestrictions(details, split) {
  //Instructions from string split by split character
  if (details != null) {
    let generation = details.split(split);
    //Basic min/max plus "cap" to identify niche cases, 0 is plain
    var min = 1;
    var max = 100000;
    var cap = 0;

    //Loop for each instruction
    for (var o = 1; o < generation.length; o++) {
      if (generation[o][0] === "<")
        max = parseInt(generation[o].substring(1));
      else if (generation[o][0] === ">")
        min = parseInt(generation[o].substring(1) + 1);
      //n means no exchange
      else if (generation[o][0] === "n")
        cap = 1;
      //e means exhange
      else if (generation[o][0] === "e")
        cap = 2;
      //x means a factor of 10
      else if (generation[o][0] == "x")
        cap = 3;
      //d means decimal
      else if (generation[o][0] == "d")
        cap = 4;
    }
    //Return as an array, not sure what type because javascript won't let me pick
    let value = [max, min, cap];
    return value;
  }
  else return "";
}

export default function Rating({ ...props }) {
  const game = useGame(props.game.id);
  const { questions } = useRatingQuestions({ game_type: game.game_type }, game);
  const [levels, setLevels] = useState();
  //console.log("Questions");
  console.log(questions);

  // once the questions have been retrieved we then generate the questionlist for the rating game
  useEffect(() => {
    if (questions !== undefined) {
      let levelQs = [];
      questions.forEach((levelQuestions, i) => {
        var newLevelQuestions = [];
        levelQuestions.forEach(q => {
          for (var i = 1; i < 12; i++) {
            let generatedCalculation = [];
            let calc = q.example_question.replace("  ", " ").split(" ");
            var correctAnswer = "";

            let questionAnswers = [];

            if (calc.length === 4) {
              //N is the random number, rand will return the generation restrictions
              var N = 0;
              var rand = RandomRestrictions(calc[3], "N");

              //Set the calculation to check results for special randoms
              generatedCalculation[0] = 0;
              generatedCalculation[1] = calc[1];
              generatedCalculation[2] = calc[2];

              //Only min/max set
              if (rand[2] == 0)
                N = Math.round(parseInt(rand[1]) + Math.random() * (parseInt(rand[0]) - parseInt(rand[1])));
              //Re-rolls any numbers that require exhange in the calculation
              else if (rand[2] == 1) {
                var temp = 0;
                while (N == 0 || (N.toString()[0] != temp.toString()[0] && !(N.length === 1 && temp.length === 1))) {
                  N = Math.round(parseInt(rand[1]) + Math.random() * (parseInt(rand[0]) - parseInt(rand[1])));
                  generatedCalculation[0] = N;
                  temp = getAnswer(generatedCalculation);
                }
              }
              //Re-roll any numbers that do not require exhange in the calculation
              else if (rand[2] == 2) {
                var temp = 0;
                while (N == 0 || (N.toString()[0] != temp.toString()[0] || N.length != temp.length)) {
                  N = Math.round(parseInt(rand[1]) + Math.random() * (parseInt(rand[0]) - parseInt(rand[1])));
                  generatedCalculation[0] = N;
                  temp = getAnswer(generatedCalculation);
                }
              }

              //Apply the generated number to the question and set the correct answer
              generatedCalculation[0] = N;
              correctAnswer = getAnswer(generatedCalculation);
            }
            //Questions with two variables that need generating
            else if (calc.length === 5) {
              //Number bonds, generates each of the three numbers of the question
              if (calc[2] == "N") {
                var min = 1;
                var max = 10;
                if (calc[4] == "20") {
                  min = 11;
                  max = 20;
                }
                var total = Math.round(min + Math.random() * (max - min));
                var value1 = Math.round(1 + Math.random() * (total - 1));
                var value2 = total - value1;
                //generatedCalculation[0] = "Complete the following number bond, " + total + ": " + value2 + ", ?";
                generatedCalculation[0] = value2 + "+ ? = " + total;
                correctAnswer = value1;
              }
              //Two number calculations covering, large numbers, factors of 10 and decimals
              else {
                //N is first number
                var N = 0;
                var rand = RandomRestrictions(calc[3], "N");

                //Normal number with no special parameters
                if (rand[2] == 0)
                  N = Math.round(rand[1] + Math.random() * (rand[0] - rand[1]));
                //Decimal numbers
                else if (rand[2] == 4)
                  N = Math.round(0.1 + Math.random() * 50) / 100;

                //O is the sceond number
                var O = 0;
                var rand2 = RandomRestrictions(calc[4], "O");

                //Normal number with no special parameters
                if (rand2[2] == 0)
                  O = Math.round(rand2[1] + Math.random() * (rand2[0] - rand2[1]));
                //Power of 10
                else if (rand2[2] == 3) {
                  var options = [10, 100, 1000, 10000, 100000];
                  O = options[Math.floor(Math.random() * options.length - 0.01)]
                }
                //Decimal number
                else if (rand2[2] == 4)
                  O = Math.round(Math.random() * (N * 50)) / 100;

                //Set the question parameters
                generatedCalculation[0] = N;
                generatedCalculation[1] = calc[1];
                generatedCalculation[2] = O;

                //Generate the correct answer
                if (calc[1] == "-")
                  correctAnswer = N - O;
                else
                  correctAnswer = N + O;

                  if(correctAnswer.toString().includes("0."))
                  {
                  correctAnswer = correctAnswer.toFixed(2);

                  if(correctAnswer[3] == "0")
                  correctAnswer = parseFloat(correctAnswer).toFixed(1);
                  }
              }
            }
            //Three part question with three generated variables
            else {
              //N is variable 1
              var N = 0;
              var rand = RandomRestrictions(calc[3], "N");
              N = Math.round(rand[1] + Math.random() * (rand[0] - rand[1]));

              //O is variable 2
              var O = 0;
              rand = RandomRestrictions(calc[3], "O");
              O = Math.round(rand[1] + Math.random() * (rand[0] - rand[1]));

              //P is variable 3
              var P = 0;
              rand = RandomRestrictions(calc[3], "P");
              P = Math.round(rand[1] + Math.random() * (rand[0] - rand[1]));

              //Build the question
              generatedCalculation[0] = N;
              generatedCalculation[1] = calc[1];
              generatedCalculation[2] = O;
              generatedCalculation[1] = calc[3];
              generatedCalculation[2] = P;

              //Set the correct answer
              correctAnswer = N + O + P;
            }

            //override for numeracy intervention
            if (q.question_key == "addsubQ29") {
              var firstNum = GenerateRandom(11, 99);
              var secondNum = GenerateRandom(11, 99);
              correctAnswer = firstNum + secondNum;
              generatedCalculation = [];
              generatedCalculation.push(firstNum);
              generatedCalculation.push("+");
              generatedCalculation.push(secondNum);
              generatedCalculation.push("=");
              var answersUsed = [];
              answersUsed.push(correctAnswer);
              for (let i = 0; i < 3; i++) {
                let wrong = GenerateUniqueRandom(22, 198, answersUsed);
                console.log(wrong);
                answersUsed.push(wrong);
                questionAnswers.push({
                  correct: false,
                  value: wrong
                })
              }
            }

            if (q.question_key == "addsubQ31") {
              var firstNum = GenerateRandom(1, 9);
              var secondNum = GenerateRandom(1, 9);
              var thirdNum = GenerateRandom(1,9);
              correctAnswer = firstNum + secondNum + thirdNum;
              generatedCalculation = [];
              generatedCalculation.push(firstNum);
              generatedCalculation.push("+");
              generatedCalculation.push(secondNum);
              generatedCalculation.push("+");
              generatedCalculation.push(thirdNum);
              generatedCalculation.push("=");
              var answersUsed = [];
              answersUsed.push(correctAnswer);
              for (let i = 0; i < 3; i++) {
                let wrong = GenerateUniqueRandom(3, 27, answersUsed);
                console.log(wrong);
                answersUsed.push(wrong);
                questionAnswers.push({
                  correct: false,
                  value: wrong
                })
              }
            }

            if (q.question_key == "addsubQ34"){//missing number
              var num1 = GenerateRandom(1, 9) * 100;
              var num2 = GenerateRandom(1, 9) * 10;
              var num3 = GenerateRandom(1, 9);
  
              correctAnswer = num2;

              generatedCalculation = [];
              generatedCalculation.push(num1);
              generatedCalculation.push("+");
              generatedCalculation.push("□");
              generatedCalculation.push("+");
              generatedCalculation.push(num3);
              generatedCalculation.push("=");
              generatedCalculation.push(num1+num2+num3);
              var answersUsed = [];
              answersUsed.push(correctAnswer);
              for (let i = 0; i < 3; i++) {
                let wrong = GenerateUniqueRandom(10, 99, answersUsed);
                console.log(wrong);
                answersUsed.push(wrong);
                questionAnswers.push({
                  correct: false,
                  value: wrong
                })
              }
            }

            if (q.question_key == "addsubQ35"){//minus 2 digit number from 3 digit number
              var num1 = GenerateRandom(1, 900);
              var num2 = GenerateRandom(1, 90);
  
              correctAnswer = num1-num2;

              generatedCalculation = [];
              generatedCalculation.push(num1);
              generatedCalculation.push("-");
              generatedCalculation.push(num2);
              generatedCalculation.push("=");
              var answersUsed = [];
              answersUsed.push(correctAnswer);
              for (let i = 0; i < 3; i++) {
                let wrong = GenerateUniqueRandom(50, 900, answersUsed);
                console.log(wrong);
                answersUsed.push(wrong);
                questionAnswers.push({
                  correct: false,
                  value: wrong
                })
              }
            }
 
            if (q.question_key == "addsubQ36"){//missing number 2
              var num1 = GenerateRandom(100, 9999);
              var num2 = GenerateRandom(1, 9);
  
              correctAnswer = num2;

              generatedCalculation = [];
              generatedCalculation.push(num1);
              generatedCalculation.push("-");
              generatedCalculation.push("□");
              generatedCalculation.push("=");
              generatedCalculation.push(num1-num2);
              var answersUsed = [];
              answersUsed.push(correctAnswer);
              for (let i = 0; i < 3; i++) {
                let wrong = GenerateUniqueRandom(10, 99, answersUsed);
                console.log(wrong);
                answersUsed.push(wrong);
                questionAnswers.push({
                  correct: false,
                  value: wrong
                })
              }
            }

             
            if (q.question_key == "addsubQ37"){//adding multiples of 10
              var num1 = GenerateRandom(100, 9000);
              var num2array = [10,100,1000];
              var num2 = num2array[GenerateRandom(0, num2array.length)];
  
              correctAnswer = num1+num2;

              generatedCalculation = [];
              generatedCalculation.push(num1);
              generatedCalculation.push("+");
              generatedCalculation.push(num2);
              generatedCalculation.push("=");
              var answersUsed = [];
              answersUsed.push(correctAnswer);
              for (let i = 0; i < 3; i++) {
                let wrong = num1 + GenerateUniqueRandom(1, 9, answersUsed)* num2array[GenerateRandom(0,num2array.length)];
                while (answersUsed.includes(wrong)){
                  wrong = num1 + GenerateUniqueRandom(1, 9, answersUsed)* num2array[GenerateRandom(0,num2array.length)];
                }
                answersUsed.push(wrong);
                questionAnswers.push({
                  correct: false,
                  value: wrong
                })
              }
            }

            if (q.question_key == "addsubQ38"){//subtracting multiples of 10
              var num1 = GenerateRandom(1001, 9000);
              var num2array = [10,100,1000];
              var num2 = num2array[GenerateRandom(0, num2array.length)];
  
              correctAnswer = num1-num2;

              generatedCalculation = [];
              generatedCalculation.push(num1);
              generatedCalculation.push("-");
              generatedCalculation.push(num2);
              generatedCalculation.push("=");
              var answersUsed = [];
              answersUsed.push(correctAnswer);
              for (let i = 0; i < 3; i++) {
                let wrong = num1 - GenerateUniqueRandom(1, 9, answersUsed)* num2array[GenerateRandom(0,num2array.length)];
                while (answersUsed.includes(wrong)){
                  wrong = num1 - GenerateUniqueRandom(1, 9, answersUsed)* num2array[GenerateRandom(0,num2array.length)];
                }
                console.log(wrong);
                answersUsed.push(wrong);
                questionAnswers.push({
                  correct: false,
                  value: wrong
                })
              }
            }

            //new questions here
             //new questions under here
  if (q.question_key == "addsub3Q1"){//numberbonds 10 only
    generatedCalculation = [];
      var total = 10;
      var value1 = Math.round(1 + Math.random() * (total - 1));
      var value2 = total - value1;
      
      correctAnswer = value1;
      generatedCalculation.push(value2);
      generatedCalculation.push("+");
      generatedCalculation.push("□");
      generatedCalculation.push("=");
      generatedCalculation.push(total);
      var answersUsed = [];
      answersUsed.push(correctAnswer);
      for (let i = 0; i < 3; i++) {
        let wrong = GenerateUniqueRandom(1, 9, answersUsed);
        console.log(wrong);
        answersUsed.push(wrong);
        questionAnswers.push({
          correct: false,
          value: wrong
        })
      }
  }

  if (q.question_key == "addsub3Q2"){//numberbonds 20 only
    generatedCalculation = [];
      var total = 10;
      var value1 = Math.round(1 + Math.random() * (total - 1));
      var value2 = total - value1;
      
      correctAnswer = value1;
      generatedCalculation.push(value2);
      generatedCalculation.push("+");
      generatedCalculation.push("□");
      generatedCalculation.push("=");
      generatedCalculation.push(total);
      var answersUsed = [];
      answersUsed.push(correctAnswer);
      for (let i = 0; i < 3; i++) {
        let wrong = GenerateUniqueRandom(1, 9, answersUsed);
        console.log(wrong);
        answersUsed.push(wrong);
        questionAnswers.push({
          correct: false,
          value: wrong
        })
      }
  }

  if (q.question_key == "addsub2Q4"){//Adding 1 or 2 to number that requires exchange
    generatedCalculation = [];
      
    var value1array = [9, 19, 29, 39, 49, 59, 69, 79, 89];
    var value1 = value1array[GenerateRandom(0, value1array.length)];

      var value2array = [1,2];
      var value2 = value2array[GenerateRandom(0, value2array.length)];
      
      correctAnswer = value1+value2;

      generatedCalculation.push(value1);
      generatedCalculation.push("+");
      generatedCalculation.push(value2);
      generatedCalculation.push("=");
      var answersUsed = [];
      answersUsed.push(correctAnswer);
      for (let i = 0; i < 3; i++) {
        let wrong = GenerateUniqueRandom(1, 9, answersUsed);
        console.log(wrong);
        answersUsed.push(wrong);
        questionAnswers.push({
          correct: false,
          value: wrong
        })
      }
  }

  if (q.question_key == "addsub2Q5"){//Subtracting 1, 2, 3, 4 or 5 from numbers less than 10
    generatedCalculation = [];
      
    var value1 = GenerateRandom(1,5);
    var value2 = GenerateRandom(value1+1,9);
      
      correctAnswer = value2-value1;

      generatedCalculation.push(value2);
      generatedCalculation.push("-");
      generatedCalculation.push(value1);
      generatedCalculation.push("=");
      var answersUsed = [];
      answersUsed.push(correctAnswer);
      for (let i = 0; i < 3; i++) {
        let wrong = GenerateUniqueRandom(1, 9, answersUsed);
        console.log(wrong);
        answersUsed.push(wrong);
        questionAnswers.push({
          correct: false,
          value: wrong
        })
      }
  }

  if (q.question_key == "addsub2Q9"){//Adding two single digit numbers that does not require exchange
    generatedCalculation = [];
      
    var value1 = GenerateRandom(1,5);
    var value2 = GenerateRandom(1,5);
      
      correctAnswer = value1+value2;

      generatedCalculation.push(value1);
      generatedCalculation.push("+");
      generatedCalculation.push(value2);
      generatedCalculation.push("=");
      var answersUsed = [];
      answersUsed.push(correctAnswer);
      for (let i = 0; i < 3; i++) {
        let wrong = GenerateUniqueRandom(1, 9, answersUsed);
        console.log(wrong);
        answersUsed.push(wrong);
        questionAnswers.push({
          correct: false,
          value: wrong
        })
      }
  }

  if (q.question_key == "addsub2Q2"){//Adding 1, 2, 3 or 4 to numbers that gives a sum between 11 and 20
    generatedCalculation = [];
      
    var value1 = GenerateRandom(1,4);
    var value2 = GenerateRandom(10,15);
      
      correctAnswer = value1+value2;

      generatedCalculation.push(value1);
      generatedCalculation.push("+");
      generatedCalculation.push(value2);
      generatedCalculation.push("=");
      var answersUsed = [];
      answersUsed.push(correctAnswer);
      for (let i = 0; i < 3; i++) {
        let wrong = GenerateUniqueRandom(1, 9, answersUsed);
        console.log(wrong);
        answersUsed.push(wrong);
        questionAnswers.push({
          correct: false,
          value: wrong
        })
      }
  }

  if (q.question_key == "addsub2Q3"){//Adding a single digit number to numbers less than 100 without needing to exchange
    generatedCalculation = [];
      
    var value1 = GenerateRandom(1,8);
    var value2 = 0;

    if(value1 == 1)
    {
      value2= GenerateRandom(20,98);

      while(value2 == 29 || value2 == 39 || value2 == 49 || value2 == 59 || value2 == 69 || value2 == 79 || value2 == 89)
      {
        value2= GenerateRandom(20,98);
      }
    }
      
    if(value1 == 2)
    {
      value2= GenerateRandom(20,97);

      while(value2 == 29 || value2 == 39 || value2 == 49 || value2 == 59 || value2 == 69 || value2 == 79 || value2 == 89
         || value2 == 28 || value2 == 38 || value2 == 48 || value2 == 58 || value2 == 68 || value2 == 78 || value2 == 88)
      {
        value2= GenerateRandom(20,97);
      }
    }

    if(value1 == 3)
    {
      value2= GenerateRandom(20,96);

      while(value2 == 29 || value2 == 39 || value2 == 49 || value2 == 59 || value2 == 69 || value2 == 79 || value2 == 89
         || value2 == 28 || value2 == 38 || value2 == 48 || value2 == 58 || value2 == 68 || value2 == 78 || value2 == 88
         || value2 == 27 || value2 == 37 || value2 == 47 || value2 == 57 || value2 == 67 || value2 == 77 || value2 == 87)
      {
        value2= GenerateRandom(20,96);
      }
    }

    if(value1 == 4)
    {
      value2= GenerateRandom(20,95);

      while(value2 == 29 || value2 == 39 || value2 == 49 || value2 == 59 || value2 == 69 || value2 == 79 || value2 == 89
         || value2 == 28 || value2 == 38 || value2 == 48 || value2 == 58 || value2 == 68 || value2 == 78 || value2 == 88
         || value2 == 27 || value2 == 37 || value2 == 47 || value2 == 57 || value2 == 67 || value2 == 77 || value2 == 87
         || value2 == 26 || value2 == 36 || value2 == 46 || value2 == 56 || value2 == 66 || value2 == 76 || value2 == 86)
      {
        value2= GenerateRandom(20,95);
      }
    }

    if(value1 == 5)
    {
      value2= GenerateRandom(20,94);

      while(value2 == 29 || value2 == 39 || value2 == 49 || value2 == 59 || value2 == 69 || value2 == 79 || value2 == 89
         || value2 == 28 || value2 == 38 || value2 == 48 || value2 == 58 || value2 == 68 || value2 == 78 || value2 == 88
         || value2 == 27 || value2 == 37 || value2 == 47 || value2 == 57 || value2 == 67 || value2 == 77 || value2 == 87
         || value2 == 26 || value2 == 36 || value2 == 46 || value2 == 56 || value2 == 66 || value2 == 76 || value2 == 86
         || value2 == 25 || value2 == 35 || value2 == 45 || value2 == 55 || value2 == 65 || value2 == 75 || value2 == 85)
      {
        value2= GenerateRandom(20,94);
      }
    }

    if(value1 == 6)
    {
      value2= GenerateRandom(20,93);

      while(value2 == 29 || value2 == 39 || value2 == 49 || value2 == 59 || value2 == 69 || value2 == 79 || value2 == 89
         || value2 == 28 || value2 == 38 || value2 == 48 || value2 == 58 || value2 == 68 || value2 == 78 || value2 == 88
         || value2 == 27 || value2 == 37 || value2 == 47 || value2 == 57 || value2 == 67 || value2 == 77 || value2 == 87
         || value2 == 26 || value2 == 36 || value2 == 46 || value2 == 56 || value2 == 66 || value2 == 76 || value2 == 86
         || value2 == 25 || value2 == 35 || value2 == 45 || value2 == 55 || value2 == 65 || value2 == 75 || value2 == 85
         || value2 == 24 || value2 == 34 || value2 == 44 || value2 == 54 || value2 == 64 || value2 == 74 || value2 == 84)
      {
        value2= GenerateRandom(20,93);
      }
    }

    if(value1 == 7)
    {
      value2= GenerateRandom(20,92);

      while(value2 == 29 || value2 == 39 || value2 == 49 || value2 == 59 || value2 == 69 || value2 == 79 || value2 == 89
         || value2 == 28 || value2 == 38 || value2 == 48 || value2 == 58 || value2 == 68 || value2 == 78 || value2 == 88
         || value2 == 27 || value2 == 37 || value2 == 47 || value2 == 57 || value2 == 67 || value2 == 77 || value2 == 87
         || value2 == 26 || value2 == 36 || value2 == 46 || value2 == 56 || value2 == 66 || value2 == 76 || value2 == 86
         || value2 == 25 || value2 == 35 || value2 == 45 || value2 == 55 || value2 == 65 || value2 == 75 || value2 == 85
         || value2 == 24 || value2 == 34 || value2 == 44 || value2 == 54 || value2 == 64 || value2 == 74 || value2 == 84
         || value2 == 23 || value2 == 33 || value2 == 43 || value2 == 53 || value2 == 63 || value2 == 73 || value2 == 83)
      {
        value2= GenerateRandom(20,92);
      }
    }

    if(value1 == 8)
    {
      value2= GenerateRandom(20,91);

      while(value2 == 29 || value2 == 39 || value2 == 49 || value2 == 59 || value2 == 69 || value2 == 79 || value2 == 89
         || value2 == 28 || value2 == 38 || value2 == 48 || value2 == 58 || value2 == 68 || value2 == 78 || value2 == 88
         || value2 == 27 || value2 == 37 || value2 == 47 || value2 == 57 || value2 == 67 || value2 == 77 || value2 == 87
         || value2 == 26 || value2 == 36 || value2 == 46 || value2 == 56 || value2 == 66 || value2 == 76 || value2 == 86
         || value2 == 25 || value2 == 35 || value2 == 45 || value2 == 55 || value2 == 65 || value2 == 75 || value2 == 85
         || value2 == 24 || value2 == 34 || value2 == 44 || value2 == 54 || value2 == 64 || value2 == 74 || value2 == 84
         || value2 == 23 || value2 == 33 || value2 == 43 || value2 == 53 || value2 == 63 || value2 == 73 || value2 == 83
         || value2 == 22 || value2 == 32 || value2 == 42 || value2 == 52 || value2 == 62 || value2 == 72 || value2 == 82)
      {
        value2= GenerateRandom(20,91);
      }
    }

      correctAnswer = value1+value2;

      generatedCalculation.push(value2);
      generatedCalculation.push("+");
      generatedCalculation.push(value1);
      generatedCalculation.push("=");
      var answersUsed = [];
      answersUsed.push(correctAnswer);
      for (let i = 0; i < 3; i++) {
        let wrong = GenerateUniqueRandom(correctAnswer + -9, correctAnswer + 9, answersUsed);
        console.log(wrong);
        answersUsed.push(wrong);
        questionAnswers.push({
          correct: false,
          value: wrong
        })
      }
  }

  if (q.question_key == "addsub2Q20"){//Adding a single digit number to numbers that requires exchange
    generatedCalculation = [];
      
    var value1 = GenerateRandom(3,8);
    var value2 = 0;

    if(value1 == 3)
    {
      var value2array = [29 , 39 , 49 , 59 , 69 , 79 , 89
         , 28 , 38 , 48 , 58 , 68 , 78 , 88
         , 27 , 37 , 47 , 57 , 67 , 77 , 87];

         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 4)
    {
      var value2array = [29 , 39 , 49 , 59 , 69 , 79 , 89
         , 28 , 38 , 48 , 58 , 68 , 78 , 88
         , 27 , 37 , 47 , 57 , 67 , 77 , 87
         , 26 , 36 , 46 , 56 , 66 , 76 , 86]

         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 5)
    {
      var value2array = [29 , 39 , 49 , 59 , 69 , 79 , 89
         , 28 , 38 , 48 , 58 , 68 , 78 , 88
         , 27 , 37 , 47 , 57 , 67 , 77 , 87
         , 26 , 36 , 46 , 56 , 66 , 76 , 86
         , 25 , 35 , 45 , 55 , 65 , 75 , 85]

       value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 6)
    {
     var value2array = [29 , 39 , 49 , 59 , 69 , 79 , 89
         , 28 , 38 , 48 , 58 , 68 , 78 , 88
         , 27 , 37 , 47 , 57 , 67 , 77 , 87
         , 26 , 36 , 46 , 56 , 66 , 76 , 86
         , 25 , 35 , 45 , 55 , 65 , 75 , 85
         , 24 , 34 , 44 , 54 , 64 , 74 , 84]
      
         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 7)
    {
      var value2array = [29 , 39 , 49 , 59 , 69 , 79 , 89
         , 28 , 38 , 48 , 58 , 68 , 78 , 88
         , 27 , 37 , 47 , 57 , 67 , 77 , 87
         , 26 , 36 , 46 , 56 , 66 , 76 , 86
         , 25 , 35 , 45 , 55 , 65 , 75 , 85
         , 24 , 34 , 44 , 54 , 64 , 74 , 84
         , 23 , 33 , 43 , 53 , 63 , 73 , 83]
      
         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 8)
    {
      var value2array = [29 , 39 , 49 , 59 , 69 , 79 , 89
         , 28 , 38 , 48 , 58 , 68 , 78 , 88
         , 27 , 37 , 47 , 57 , 67 , 77 , 87
         , 26 , 36 , 46 , 56 , 66 , 76 , 86
         , 25 , 35 , 45 , 55 , 65 , 75 , 85
         , 24 , 34 , 44 , 54 , 64 , 74 , 84
         , 23 , 33 , 43 , 53 , 63 , 73 , 83
         , 22 , 32 , 42 , 52 , 62 , 72 , 82]
      
         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

      correctAnswer = value1+value2;

      generatedCalculation.push(value2);
      generatedCalculation.push("+");
      generatedCalculation.push(value1);
      generatedCalculation.push("=");
      var answersUsed = [];
      answersUsed.push(correctAnswer);
      for (let i = 0; i < 3; i++) {
        let wrong = GenerateUniqueRandom(correctAnswer + -9, correctAnswer + 9, answersUsed);
        console.log(wrong);
        answersUsed.push(wrong);
        questionAnswers.push({
          correct: false,
          value: wrong
        })
      }
  }

  if (q.question_key == "addsub2Q6"){ //Subtracting 1, 2, 3 or 4 from numbers more than 10 and less than 19
    generatedCalculation = [];
      
    var value1 = GenerateRandom(1,4);
    var value2 = GenerateRandom(10,18);
      
      correctAnswer = value2-value1;

      generatedCalculation.push(value2);
      generatedCalculation.push("-");
      generatedCalculation.push(value1);
      generatedCalculation.push("=");
      var answersUsed = [];
      answersUsed.push(correctAnswer);
      for (let i = 0; i < 3; i++) {
        let wrong = GenerateUniqueRandom(correctAnswer + -9, correctAnswer + 9, answersUsed);
        console.log(wrong);
        answersUsed.push(wrong);
        questionAnswers.push({
          correct: false,
          value: wrong
        })
      }
  }

  if (q.question_key == "addsub2Q15"){ //Subtracting a single digit number from numbers less than 100, without needing to exchange
    generatedCalculation = [];
      
    var value1 = GenerateRandom(2,8);
    var value2 = 0;
 
    if(value1 == 2)
    {
      value2= GenerateRandom(20,99);

      while(value2 == 20 || value2 == 30 || value2 == 40 || value2 == 50 || value2 == 60 || value2 == 70 || value2 == 80 || value2 == 90
         || value2 == 21 || value2 == 31 || value2 == 41 || value2 == 51 || value2 == 61 || value2 == 71 || value2 == 81 || value2 == 91)
      {
        value2= GenerateRandom(20,99);
      }
    }

    if(value1 == 3)
    {
      value2= GenerateRandom(20,99);

      while(value2 == 20 || value2 == 30 || value2 == 40 || value2 == 50 || value2 == 60 || value2 == 70 || value2 == 80 || value2 == 90
         || value2 == 21 || value2 == 31 || value2 == 41 || value2 == 51 || value2 == 61 || value2 == 71 || value2 == 81 || value2 == 91
         || value2 == 22 || value2 == 32 || value2 == 42 || value2 == 52 || value2 == 62 || value2 == 72 || value2 == 82 || value2 == 92)
      {
        value2= GenerateRandom(20,99);
      }
    }

    if(value1 == 4)
    {
      value2= GenerateRandom(20,99);

      while(value2 == 20 || value2 == 30 || value2 == 40 || value2 == 50 || value2 == 60 || value2 == 70 || value2 == 80 || value2 == 90
         || value2 == 21 || value2 == 31 || value2 == 41 || value2 == 51 || value2 == 61 || value2 == 71 || value2 == 81 || value2 == 91
         || value2 == 22 || value2 == 32 || value2 == 42 || value2 == 52 || value2 == 62 || value2 == 72 || value2 == 82 || value2 == 92
         || value2 == 23 || value2 == 33 || value2 == 43 || value2 == 53 || value2 == 63 || value2 == 73 || value2 == 83 || value2 == 93)
      {
        value2= GenerateRandom(20,99);
      }
    }

    if(value1 == 5)
    {
      value2= GenerateRandom(20,99);

      while(value2 == 20 || value2 == 30 || value2 == 40 || value2 == 50 || value2 == 60 || value2 == 70 || value2 == 80 || value2 == 90
         || value2 == 21 || value2 == 31 || value2 == 41 || value2 == 51 || value2 == 61 || value2 == 71 || value2 == 81 || value2 == 91
         || value2 == 22 || value2 == 32 || value2 == 42 || value2 == 52 || value2 == 62 || value2 == 72 || value2 == 82 || value2 == 92
         || value2 == 23 || value2 == 33 || value2 == 43 || value2 == 53 || value2 == 63 || value2 == 73 || value2 == 83 || value2 == 93
         || value2 == 24 || value2 == 34 || value2 == 44 || value2 == 54 || value2 == 64 || value2 == 74 || value2 == 84 || value2 == 94)
      {
        value2= GenerateRandom(20,99);
      }
    }

    if(value1 == 6)
    {
      value2= GenerateRandom(20,99);

      while(value2 == 20 || value2 == 30 || value2 == 40 || value2 == 50 || value2 == 60 || value2 == 70 || value2 == 80 || value2 == 90
         || value2 == 21 || value2 == 31 || value2 == 41 || value2 == 51 || value2 == 61 || value2 == 71 || value2 == 81 || value2 == 91
         || value2 == 22 || value2 == 32 || value2 == 42 || value2 == 52 || value2 == 62 || value2 == 72 || value2 == 82 || value2 == 92
         || value2 == 23 || value2 == 33 || value2 == 43 || value2 == 53 || value2 == 63 || value2 == 73 || value2 == 83 || value2 == 93
         || value2 == 24 || value2 == 34 || value2 == 44 || value2 == 54 || value2 == 64 || value2 == 74 || value2 == 84 || value2 == 94
         || value2 == 25 || value2 == 35 || value2 == 45 || value2 == 55 || value2 == 65 || value2 == 75 || value2 == 85 || value2 == 95)
      {
        value2= GenerateRandom(20,99);
      }
    }

    if(value1 == 7)
    {
      value2= GenerateRandom(20,99);

      while(value2 == 20 || value2 == 30 || value2 == 40 || value2 == 50 || value2 == 60 || value2 == 70 || value2 == 80 || value2 == 90
         || value2 == 21 || value2 == 31 || value2 == 41 || value2 == 51 || value2 == 61 || value2 == 71 || value2 == 81 || value2 == 91
         || value2 == 22 || value2 == 32 || value2 == 42 || value2 == 52 || value2 == 62 || value2 == 72 || value2 == 82 || value2 == 92
         || value2 == 23 || value2 == 33 || value2 == 43 || value2 == 53 || value2 == 63 || value2 == 73 || value2 == 83 || value2 == 93
         || value2 == 24 || value2 == 34 || value2 == 44 || value2 == 54 || value2 == 64 || value2 == 74 || value2 == 84 || value2 == 94
         || value2 == 25 || value2 == 35 || value2 == 45 || value2 == 55 || value2 == 65 || value2 == 75 || value2 == 85 || value2 == 95
         || value2 == 26 || value2 == 36 || value2 == 46 || value2 == 56 || value2 == 66 || value2 == 76 || value2 == 86 || value2 == 96)
      {
        value2= GenerateRandom(20,99);
      }
    }

    if(value1 == 8)
    {
      value2= GenerateRandom(20,99);

      while(value2 == 20 || value2 == 30 || value2 == 40 || value2 == 50 || value2 == 60 || value2 == 70 || value2 == 80 || value2 == 90
         || value2 == 21 || value2 == 31 || value2 == 41 || value2 == 51 || value2 == 61 || value2 == 71 || value2 == 81 || value2 == 91
         || value2 == 22 || value2 == 32 || value2 == 42 || value2 == 52 || value2 == 62 || value2 == 72 || value2 == 82 || value2 == 92
         || value2 == 23 || value2 == 33 || value2 == 43 || value2 == 53 || value2 == 63 || value2 == 73 || value2 == 83 || value2 == 93
         || value2 == 24 || value2 == 34 || value2 == 44 || value2 == 54 || value2 == 64 || value2 == 74 || value2 == 84 || value2 == 94
         || value2 == 25 || value2 == 35 || value2 == 45 || value2 == 55 || value2 == 65 || value2 == 75 || value2 == 85 || value2 == 95
         || value2 == 26 || value2 == 36 || value2 == 46 || value2 == 56 || value2 == 66 || value2 == 76 || value2 == 86 || value2 == 96
         || value2 == 27 || value2 == 37 || value2 == 47 || value2 == 57 || value2 == 67 || value2 == 77 || value2 == 87 || value2 == 97)
      {
        value2= GenerateRandom(20,99);
      }
    }

      correctAnswer = value2-value1;

      generatedCalculation.push(value2);
      generatedCalculation.push("-");
      generatedCalculation.push(value1);
      generatedCalculation.push("=");
      var answersUsed = [];
      answersUsed.push(correctAnswer);
      for (let i = 0; i < 3; i++) {
        let wrong = GenerateUniqueRandom(correctAnswer + -9, correctAnswer + 9, answersUsed);
        console.log(wrong);
        answersUsed.push(wrong);
        questionAnswers.push({
          correct: false,
          value: wrong
        })
      }
  }

  if (q.question_key == "addsub2Q16"){ //Subtracting a single digit number from numbers less than 100 that need to exchange
    generatedCalculation = [];
      
    var value1 = GenerateRandom(2,8);
    var value2 = 0;
 
    if(value1 == 2)
    {
      var value2array = [20 ,30 ,40 ,50 ,60 ,70 ,80 ,90
         ,21 ,31 ,41 ,51 ,61 ,71 ,81 ,91]
      
         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 3)
    {
      var value2array = [20 ,30 ,40 ,50 ,60 ,70 ,80 ,90
         ,21 ,31 ,41 ,51 ,61 ,71 ,81 ,91
         ,22 ,32 ,42 ,52 ,62 ,72 ,82 ,92]
      
         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 4)
    {
      var value2array = [20 ,30 ,40 ,50 ,60 ,70 ,80 ,90
         ,21 ,31 ,41 ,51 ,61 ,71 ,81 ,91
         ,22 ,32 ,42 ,52 ,62 ,72 ,82 ,92
         ,23 ,33 ,43 ,53 ,63 ,73 ,83 ,93]
      
         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 5)
    {
      var value2array = [20 ,30 ,40 ,50 ,60 ,70 ,80 ,90
         ,21 ,31 ,41 ,51 ,61 ,71 ,81 ,91
         ,22 ,32 ,42 ,52 ,62 ,72 ,82 ,92
         ,23 ,33 ,43 ,53 ,63 ,73 ,83 ,93
         ,24 ,34 ,44 ,54 ,64 ,74 ,84 ,94]
      
         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 6)
    {
      var value2array = [20 ,30 ,40 ,50 ,60 ,70 ,80 ,90
         ,21 ,31 ,41 ,51 ,61 ,71 ,81 ,91
         ,22 ,32 ,42 ,52 ,62 ,72 ,82 ,92
         ,23 ,33 ,43 ,53 ,63 ,73 ,83 ,93
         ,24 ,34 ,44 ,54 ,64 ,74 ,84 ,94
         ,25 ,35 ,45 ,55 ,65 ,75 ,85 ,95]
      
      value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 7)
    {
      var value2array = [20 ,30 ,40 ,50 ,60 ,70 ,80 ,90
         ,21 ,31 ,41 ,51 ,61 ,71 ,81 ,91
         ,22 ,32 ,42 ,52 ,62 ,72 ,82 ,92
         ,23 ,33 ,43 ,53 ,63 ,73 ,83 ,93
         ,24 ,34 ,44 ,54 ,64 ,74 ,84 ,94
         ,25 ,35 ,45 ,55 ,65 ,75 ,85 ,95
         ,26 ,36 ,46 ,56 ,66 ,76 ,86 ,96]
      
         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 8)
    {
      var value2array = [20 ,30 ,40 ,50 ,60 ,70 ,80 ,90
         ,21 ,31 ,41 ,51 ,61 ,71 ,81 ,91
         ,22 ,32 ,42 ,52 ,62 ,72 ,82 ,92
         ,23 ,33 ,43 ,53 ,63 ,73 ,83 ,93
         ,24 ,34 ,44 ,54 ,64 ,74 ,84 ,94
         ,25 ,35 ,45 ,55 ,65 ,75 ,85 ,95
         ,26 ,36 ,46 ,56 ,66 ,76 ,86 ,96
         ,27 ,37 ,47 ,57 ,67 ,77 ,87 ,97]
      
         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

      correctAnswer = value2-value1;

      generatedCalculation.push(value2);
      generatedCalculation.push("-");
      generatedCalculation.push(value1);
      generatedCalculation.push("=");
      var answersUsed = [];
      answersUsed.push(correctAnswer);
      for (let i = 0; i < 3; i++) {
        let wrong = GenerateUniqueRandom(correctAnswer + -9, correctAnswer + 9, answersUsed);
        console.log(wrong);
        answersUsed.push(wrong);
        questionAnswers.push({
          correct: false,
          value: wrong
        })
      }
  }


  function AddCommas(num){
    var numString = num.toString();
    var tempString;
  
   if(!isNaN(+num)){ //true if number, false if not
  if(num >=1){
  
  
  console.log(numString);
    if(numString.length >=4 && numString.length < 7){
        tempString = numString.substring(0,(numString.length - 3));
        tempString += ',';
        tempString += numString.substring((tempString.length - 1),numString.length);
        numString = tempString;
        console.log(numString);
  
    }
    else if(numString.length >=7){
      tempString = numString.substring(0,(numString.length - 3));
      tempString += ',';
      tempString += numString.substring((tempString.length - 1),numString.length);
      numString = tempString;
      tempString = numString.substring(0,(numString.length - 7));
      tempString += ',';
      tempString += numString.substring((tempString.length - 1),numString.length);
      numString = tempString;
      console.log(numString);
  
    }
  }
   }
    return numString;
  }


            if (correctAnswer.toString().indexOf(".") != -1) {
              correctAnswer = parseFloat(correctAnswer).toFixed(2)
            }

            //Add correct answer
            let wrongAnswers = [];
            questionAnswers.push({
              correct: true,
              value: correctAnswer
            });

            if (q.question_key != "addsubQ29" && q.question_key != "addsubQ31" && q.question_key != "addsubQ34" && q.question_key != "addsubQ35" && q.question_key != "addsubQ36" && q.question_key != "addsubQ37" && q.question_key != "addsubQ38"
             && q.question_key != "addsub3Q1" && q.question_key != "addsub3Q2" && q.question_key != "addsub2Q4" && q.question_key != "addsub2Q5" && q.question_key != "addsub2Q9" && q.question_key != "addsub2Q2" && q.question_key != "addsub2Q3"
             && q.question_key != "addsub2Q20" && q.question_key != "addsub2Q6" && q.question_key != "addsub2Q15" && q.question_key != "addsub2Q16"){
              //Generate incorrect answers
              for (var n = 1; n < 4; n++)
              {
                var newIncorrectAnswer = getWrongAnswer(
                  correctAnswer,
                  wrongAnswers
                );
                wrongAnswers.push(newIncorrectAnswer);
                questionAnswers.push({
                  correct: false,
                  value: newIncorrectAnswer
                });
              }
            }

            //Mix up answers
            shuffleArray(questionAnswers);

            for (let x = 0; x < generatedCalculation.length; x++) {
              const gc = generatedCalculation[x];
              if (String(gc).includes(".") == false){
                if (gc >= 1000){
                  generatedCalculation[x] = AddCommas(String(gc));
                  console.log(gc)
                }
              }
            }

            let questionText = generatedCalculation.join(" ");
      
            questionAnswers.forEach(qa => {
              if (String(qa.value).includes(".") == false){
                qa.value = AddCommas(String(qa.value));
                console.log(qa.value);
              }
            });

            let questionObj = {
              question: questionText,
              answers: questionAnswers,
              topic_id: q.topic_id
            };

            newLevelQuestions.push(questionObj);
          }
        });
        shuffleArray(newLevelQuestions);
        levelQs[i] = newLevelQuestions;
      });
      setLevels(levelQs);
    }
  }, [questions]);

  return levels !== undefined ? (
    <RatingGame
      questionslist={levels}
      onBack={() => {
        navigate(`/games/${game.id}`);
      }}
      game={game}
      endless={props.endless}
      initialLevel={props.initialLevel}
    />
  ) : (
      <LoadingScreen />
    );
}
